module.exports = __webpack_public_path__ + "img/noise.fdf17598.png";